import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-conversation-list-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tw-space-y-3 tw-p-4">
      <div *ngFor="let item of skeletonItems" 
           class="tw-group tw-relative tw-cursor-pointer tw-transition-all tw-duration-300 tw-ease-out tw-border tw-border-transparent tw-rounded-2xl tw-px-4 tw-py-4">
        <div class="tw-flex tw-items-start tw-gap-4">
          <!-- Avatar Skeleton -->
          <div class="tw-relative tw-flex-shrink-0">
            <div class="tw-w-14 tw-h-14 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse"></div>
            <!-- Online status skeleton -->
            <div class="tw-absolute tw--bottom-1 tw--right-1">
              <div class="tw-w-4 tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse"></div>
            </div>
          </div>

          <!-- Content Skeleton -->
          <div class="tw-flex-1 tw-min-w-0" [class.tw-hidden]="collapsedSidebar">
            <!-- Name and Time -->
            <div class="tw-flex tw-justify-between tw-items-start tw-gap-3 tw-mb-2">
              <div class="tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-md tw-animate-pulse tw-w-32"></div>
              <div class="tw-h-3 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-md tw-animate-pulse tw-w-16"></div>
            </div>

            <!-- Last Message -->
            <div class="tw-flex tw-items-start tw-gap-2.5">
              <div class="tw-h-3 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-md tw-animate-pulse tw-w-48"></div>
            </div>
          </div>
        </div>

        <!-- Shimmer effect overlay -->
        <div class="tw-absolute tw-inset-0 tw-rounded-2xl tw-opacity-30 tw-bg-gradient-to-r tw-from-transparent tw-via-white/20 tw-to-transparent dark:tw-via-slate-700/20 tw-translate-x-[-100%] tw-animate-shimmer tw-pointer-events-none"></div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
    .tw-animate-shimmer {
      animation: shimmer 2s infinite;
    }
  `]
})
export class ConversationListSkeletonComponent {
  @Input() itemCount: number = 6;
  @Input() collapsedSidebar: boolean = false;

  get skeletonItems() {
    return Array.from({ length: this.itemCount }, (_, i) => i);
  }
}
